/* ==========================================================================
   Future Aesthetics — <fa-countdown>
   Counts down to a date in the announcement bar. Falls back to an evergreen
   rolling window when no end date is set, so the bar never shows 00:00:00:00
   on a store that forgot to update the drop date.

   Attributes:
     data-end-date   ISO date/time to count down to (optional)
     data-repeat-hours  rolling window length when no end date is set
     data-expired-text  what to show once the timer runs out
   ========================================================================== */

(function () {
  'use strict';

  class FaCountdown extends HTMLElement {
    connectedCallback() {
      this.parts = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };

      this.target = this.resolveTarget();
      if (!this.target) return;

      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    resolveTarget() {
      const raw = this.dataset.endDate;

      if (raw) {
        const parsed = new Date(raw);
        if (!Number.isNaN(parsed.getTime())) return parsed;
      }

      // No usable date: roll forward in fixed windows from the current epoch so
      // every visitor sees a consistent, always-running timer.
      const windowHours = parseFloat(this.dataset.repeatHours) || 72;
      const windowMs = windowHours * 3600 * 1000;
      const now = Date.now();
      return new Date(Math.ceil(now / windowMs) * windowMs);
    }

    tick() {
      const remaining = this.target.getTime() - Date.now();

      if (remaining <= 0) {
        window.clearInterval(this.timer);
        this.expire();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      this.set('days', Math.floor(totalSeconds / 86400));
      this.set('hours', Math.floor((totalSeconds % 86400) / 3600));
      this.set('minutes', Math.floor((totalSeconds % 3600) / 60));
      this.set('seconds', totalSeconds % 60);
    }

    set(key, value) {
      const node = this.parts[key];
      if (!node) return;

      const padded = String(value).padStart(2, '0');
      if (node.textContent !== padded) node.textContent = padded;
    }

    expire() {
      const message = this.dataset.expiredText;
      if (message) {
        this.textContent = message;
      } else {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('fa-countdown')) {
    customElements.define('fa-countdown', FaCountdown);
  }
})();
